import { render, staticRenderFns } from "./PlanFactDates.vue?vue&type=template&id=0bd2b566"
import script from "./PlanFactDates.vue?vue&type=script&lang=js"
export * from "./PlanFactDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports